module.exports = __webpack_public_path__ + "static/media/ComponentY.d6f1146a.svg";